<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>Open Text</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <form [formGroup]="form">
    <!-- Description -->
    <ion-item>
      <ion-label position="floating">Description</ion-label>
      <ion-input id="input-description-modifier"
                 autofocus="true"
                 maxlength="50"
                 type="text"
                 formControlName="description"></ion-input>
    </ion-item>
    <!-- Price Increase -->
    <ion-item>
      <ion-label position="floating">Price Increase ($)</ion-label>
      <ion-input id="input-price-increase"
                 appNumberBehavior
                 type="text"
                 formControlName="price"></ion-input>
    </ion-item>
  </form>
</ion-content>
<ion-footer>
  <ion-toolbar mode="md"
               color="light">
    <ion-buttons slot="end">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  [disabled]="form.pristine || form.invalid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onSaveNotes()">SAVE</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
